export const home = {
    title1:'жилище',
    title2:'сектор',
    title3:'продукт',
    title4:'анкета',
    title5:'язык',
    welcome:'Добро пожаловать на этот сайт',
    login:'регистрация'
}
export const center = {
    title1:' о нас ',
    title2:'отраслевая демонстрация ',
    title3:'Показ продукции ',
    more:'больше ',
    titlex:'анкета'
}


export const bottom = {
    address:'адрес ',
    email:' почтовый ящик ',
    phone:'телефон ',
    Postal :'почтовый индекс '
}
export const paper = {
    submit:'подтверждать представление',
    btn:'Участие',
    tips:'передача успешно завершена '
}
export const login = {
    title:' номер счёта',
    email:'почтовый',
    pwd:'пароль ',
    titlel:' регистрация номера счета ',
    titler:'забыть пароль ',
    btn:'вход '
}
export const register = {
    title:' регистрация номера счета ',
    code:'код',
    email:'почтовый',
    pwd:'пароль ',
    pwd2:'подтвердить ',
    titlel:'номер счёта ',
    titler:'забыть пароль ',
    btn:'регистрация ',
    codeTips:'добывать'
}
export const forgot = {
    title:'забыть пароль ',
    code:'код',
    email:'почтовый',
    pwd:'старый',
    pwd2:'пароль',
    titlel:'номер счёта ',
    titler:'забыть пароль ',
    btn:'подтверждать изменение ',
    codeTips:'добывать'
}
export const active = {
    tips:'Г - н Чжан получил 100 долларов за анкету! ',
    title1:'немедленная ',
    title2:'выполнить задачу входа ',
    title3:'получить премию в $50 ',
    title4:'участие',
    title22:'выполнить задачу ',
    title23:'выполнить задачу модернизации ',
    popup1:' Регистрация успешно, получить награду в 100 долларов;  Идите, выполняйте другие задания! ',
    popup2:'сегодня Подпишись получить 20 очков ',
    popup3:'Извините, в настоящее время членство недостаточно, чтобы войти в соответствующие задачи, пожалуйста, немедленно связаться с сервисом! ',
    popup1Btn:' Понял. ',
    popup2Btn:' Понял. ',
    popup3Btn:'контактный халат',
}


// WEBPACK FOOTER //
// ./src/i18n/Russian.js